var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-classify"},_vm._l((_vm.form),function(item,index){return _c('node',{ref:'node'+index,refInFor:true,attrs:{"change":_vm.handleChange,"data":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }